import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import "@/styles/portfolio.css";
import "@/styles/admin.css";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="admin-shell admin-loading">Lädt…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-shell admin-login-shell">
      <Link to="/" className="admin-back" data-testid="admin-login-back">
        ← Zur Website
      </Link>
      <div className="admin-login-card" data-testid="admin-login-card">
        <span className="eyebrow">ADMIN</span>
        <h1 className="display admin-login-title">
          <span className="italic">Backstage</span>.
        </h1>
        <p className="admin-login-lead">
          Melde dich an, um Blog-Beiträge zu verfassen und zu verwalten.
        </p>

        <form onSubmit={handleSubmit} className="admin-form">
          <label className="admin-field">
            <span className="admin-label">E-Mail</span>
            <input
              type="email"
              className="admin-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              autoFocus
              data-testid="admin-login-email"
            />
          </label>
          <label className="admin-field">
            <span className="admin-label">Passwort</span>
            <input
              type="password"
              className="admin-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              data-testid="admin-login-password"
            />
          </label>

          {error && (
            <div className="admin-error" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="btn btn--solid admin-submit"
            data-testid="admin-login-submit"
          >
            <span>{submitting ? "Anmelden…" : "Anmelden"}</span>
            <span className="btn__arrow">→</span>
          </button>
        </form>
      </div>
    </div>
  );
}
